import degreesConfig from "@2u-landing-pages/constants/configs/degrees.json";

const programConfigs = degreesConfig.programs.ucb;

export const ucb = {
  slug: "ucb",
  name: "UC Berkeley",
  colors: {
    primary1: "#ffffff",
    primary2: "#fecf48",
    primary3: "#d23228",
    primary4: "#1576d4",
    text: "#fff",
  },
  fonts: {
    url: "https://whitelabel.2u.com/cdn/v1/b2b57977-3799-4958-b13b-4db6f983e929/marketing/whitelabel.fonts.min.css?ver=1.0",
    base: "Inter, sans-serif",
  },
  programConfigs,
};
